import Company2HubspotSelector from './Company2HubspotSelector/Company2HubspotSelector.vue'
import Configuration from '@/agilis/util/Configuration'
import TrackerDataTableItemEdit from '@/applications/scrum/components/TrackerDataTable/TrackerDataTableItemEdit/TrackerDataTableItemEdit.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Company2TableItemEdit',

  components: {
    Company2HubspotSelector,
    TrackerDataTableItemEdit
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerType: 'contextStore/trackerType'
    })
  },

  methods: {
    userCanAccessHubspot () {
      const privilegeId = `/${this.applicationId}`
        .concat(`/workspace/${this.workspaceId}`)
        .concat(`/tracker/${this.trackerTypeId}`)
        .concat(`/hubspot`)
      return Configuration.auth.userHasPrivilege(privilegeId) && this.$attrs.mode === 'insert'
    }
  }
}
